import React, { useEffect, useState } from 'react';
import { Button, Grid, GridColumn, Modal, Segment, Icon, Table, TableHeader, TableHeaderCell, TableRow, TableCell, TableBody, Tab } from 'semantic-ui-react';
import { Rnd } from 'react-rnd';
import i18next from 'i18next';
import { useTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ErrorSegment, VideoPlayer } from '../../..';
import { Consts, Styles } from '../../../../res';
// import PresentValues from '../../../../res/pdfs/presentvalues.pdf';
import WorkSpaceHelpPdf from '../../../../res/pdfs/difrworkspace.pdf';
import ExamInstructionsHelpPdf from '../../../../res/pdfs/difrexaminstructions.pdf';
import TbsPdfReader from '../TbsPdfReader';
// import QuestionTranslationModal from '../QuestionTranslationModal';

const { noExtraSpaces } = Styles;

const ExamFooter = (props) => {
    const { Q, Qindex, isMockExam, isViewOnly, summary,
        onSelectQuestion, questions, t, onGoingExam, onFlagQuestion,
        userOnFinishExam, examFinishingLoading, additionalStyles,
        setQuestionsFilter
    } = props;

    // const isArabic = i18next.language === 'ar';

    const [showExplanation, setShowExplanation] = useState(false);
    const [showFinishConfirm, setShowFinishConfirm] = useState(false);
    const [showFinishAllConfirm, setShowFinishAllConfirm] = useState(false);
    const [showNav, setShowNav] = useState(false);
    const [showHelp, setShowHelp] = useState(false);
    const [reachToLastQuestion, setReachToLastQuestion] = useState(false);
    const [reachToSummary, setReachToSummary] = useState(false);
    // const [showTranslationModal, setShowTranslationModal] = useState(false);
    useEffect(() => {
        if ((Qindex >= questions.length - 1)) setReachToLastQuestion(true);
        else setReachToLastQuestion(false);
        //eslint-disable-next-line
    }, [Q]);

    useEffect(() => {
        if (summary.show && !reachToSummary) setReachToSummary(true);
        //eslint-disable-next-line
    }, [summary.show]);

    const buttonStyle = {
        boxShadow: 'none !important',
        borderRadius: 0,
        borderLeft: i18next.language === 'ar' ? 'solid white' : 'none',
        borderRight: i18next.language !== 'ar' ? 'solid white' : 'none',
        backgroundColor: 'transparent',
        color: 'black'
    };

    const StyledButton = styled(Button)`
        box-shadow: none !important;
        border-radius: 0 !important;
        border-left: ${() => (i18next.language === 'ar' ? 'solid white' : 'none')} !important;
        border-right: ${() => (i18next.language !== 'ar' ? 'solid white' : 'none')} !important;
        background-color: transparent !important;
        color: black !important;
        transition: color 0.2s ease;

        &:hover {
            color: red !important;  /* hover text color */
        }
        `;

    if (!Q) return null;

    const flaggedQuestions = questions.filter(q => q.isFlagged).length;
    const unattemptedQuestions = questions.filter(q => !(q?.answerOptionId || q?.answerText || q?.answerJson)).length;

    return (
        <>
            <Segment className="difr-custom-footer-class-for-ar" inverted basic style={{ ...noExtraSpaces, backgroundColor: "#f2f2f2", borderTop: 'solid black 1px', ...additionalStyles, position: 'absolute', left: 0, bottom: 0, width: '100%' }}>
                <Grid stackable columns='3' verticalAlign='middle' style={noExtraSpaces}>
                    <GridColumn width='3' style={noExtraSpaces}>
                        {/* <a title={t('Attachments')} href={PresentValues} rel='noreferrer' target='_blank'>
                            <Button icon='attach' style={buttonStyle} />
                        </a> */}
                        {/* <Button icon='translate' content={t('Translate')} style={buttonStyle} onClick={() => setShowTranslationModal(true)} /> */}
                        <Button.Group>
                            {isMockExam && <StyledButton onClick={() => setShowHelp(true)} labelPosition='left' icon='question circle outline' content={t('examFooter.buttons.help').toUpperCase()} style={buttonStyle} />}

                            {(reachToSummary) && !summary.show && <StyledButton content={t('examFooter.buttons.reviewAnswers')} onClick={() => { setQuestionsFilter("ALL"); summary.setShowSummary(!summary.show); }} icon='sign-in' labelPosition='left' style={buttonStyle} />}
                            {summary.show && <StyledButton
                                content={t(onGoingExam.isViewOnly ? 'examFooter.buttons.exit' : 'examFooter.buttons.endExam').toUpperCase()}
                                loading={examFinishingLoading}
                                labelPosition='left'
                                icon='sign-out'
                                onClick={() => onGoingExam.isViewOnly ? userOnFinishExam(onGoingExam) : ((unattemptedQuestions > 0 && !isMockExam) ? setShowFinishConfirm(true) : setShowFinishAllConfirm(true))}
                                style={buttonStyle}
                            />}
                        </Button.Group>
                    </GridColumn>

                    <GridColumn width='3' textAlign='center' style={noExtraSpaces}>
                        {/* {!summary.show && !isMockExam && (Q.answerText || Q.answerOptionId || isViewOnly) ? <Button icon='video play' labelPosition='left' content={t('Explanation')} onClick={() => setShowExplanation(true)} style={buttonStyle} /> : null} */}
                    </GridColumn>

                    <GridColumn width='10' textAlign='right' style={noExtraSpaces}>
                        {!summary.show && <Button.Group>
                            <StyledButton disabled={Qindex <= 0} onClick={() => onSelectQuestion(questions[Qindex - 1])} labelPosition='left' icon='arrow left' content={t('examFooter.buttons.back').toUpperCase()} style={buttonStyle} />
                            {!reachToSummary && <StyledButton icon='th' content={t('examFooter.buttons.navigator')} onClick={() => setShowNav(p => !p)} style={buttonStyle} />}
                            <StyledButton onClick={() => reachToLastQuestion ? summary.setShowSummary(true) : onSelectQuestion(questions[Qindex + 1])} labelPosition='right' icon='arrow right' content={t('examFooter.buttons.next').toUpperCase()} style={buttonStyle} />
                        </Button.Group>}

                        {summary.show && !isViewOnly &&
                            <Button.Group compact>
                                <StyledButton onClick={() => setQuestionsFilter("ALL")} labelPosition='left' icon='clone' content={t('examFooter.review.reviewAll')} style={buttonStyle} />
                                {unattemptedQuestions > 0 && <StyledButton onClick={() => setQuestionsFilter("UNATTEMPTED")} labelPosition='left' icon='list' content={t('examFooter.review.reviewNotAttempted')} style={buttonStyle} />}
                                {flaggedQuestions > 0 && <StyledButton onClick={() => setQuestionsFilter("FLAGGED")} labelPosition='left' icon='flag' content={t('examFooter.review.reviewFlagged')} style={buttonStyle} />}
                            </Button.Group>
                        }
                    </GridColumn>
                </Grid>
                {/* <QuestionTranslationModal show={showTranslationModal} setShow={setShowTranslationModal}
                question={Q} lang={isArabic ? 'en' : 'ar'} examRoundId={onGoingExam.examRoundId} /> */}
            </Segment>


            <Modal
                onClose={() => setShowExplanation(false)}
                open={showExplanation}
                content={Q && Q.correctAnswer && Q.correctAnswer.explanations && Q.correctAnswer.explanations.videos.length ? <VideoPlayer kind={Consts.VIDEOS_KINDS.EXPLANATION} videoDetails={{ ...Q.correctAnswer.explanations.videos[0], ...Q }} onClose={() => setShowExplanation(false)} /> : <ErrorSegment text={t('ComingSoon')} icon='wait' />}
                basic={Q && Q.correctAnswer && Q.correctAnswer.explanations && Q.correctAnswer.explanations.videos.length ? true : false}
                size='large'
                centered
                closeIcon={!(Q && Q.correctAnswer && Q.correctAnswer.explanations && Q.correctAnswer.explanations.videos.length)}
                closeOnDimmerClick={false}
            />

            <Modal
                size='large'
                open={showFinishConfirm}
                header={<div className='tw-p-3 tw-bg-[#dcdddd]'><p>{t('examFooter.modals.endExamTitle')}</p></div>}
                content={<div className='tw-bg-[#dcdddd] tw-p-5'>
                    <div className=' tw-flex tw-flex-row tw-items-center tw-gap-10'>
                        <div><Icon name='exclamation triangle' size='big' /></div>
                        <p>{t("examFooter.modals.unattemptedWarning", { count: unattemptedQuestions })}</p>
                    </div>
                    <div className='tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-3 tw-my-5'>
                        <Button onClick={() => { setShowFinishAllConfirm(true); setShowFinishConfirm(false); }} content={t("examFooter.common.yes")} />
                        <Button onClick={() => setShowFinishConfirm(false)} content={t("examFooter.common.no")} />
                    </div>
                </div>}
            />

            <Modal
                size='large'
                open={showFinishAllConfirm}
                header={<div className='tw-p-3 tw-bg-[#dcdddd]'><p>{t('examFooter.modals.endExamTitle')}</p></div>}
                content={<div className='tw-bg-[#dcdddd] tw-p-5'>
                    <div className='tw-flex tw-flex-row tw-items-center tw-gap-10'>
                        <div><Icon name='exclamation triangle' size='big' /></div>
                        <div>
                            <p>{t("examFooter.modals.finishText1")}</p>
                            <p>{t("examFooter.modals.finishText2")}</p>
                        </div>
                    </div>
                    <div className='tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-3 tw-my-5'>
                        <Button onClick={() => { userOnFinishExam(onGoingExam); setShowFinishAllConfirm(false); }} content={t("examFooter.common.yes")} />
                        <Button onClick={() => setShowFinishAllConfirm(false)} content={t("examFooter.common.no")} />
                    </div>
                </div>}
            />

            {showNav && <Rnd
                default={{
                    x: (window.innerWidth - 600) / 2,
                    y: -(window.innerHeight + 400) / 2,
                    width: 600,
                    height: 400,
                }}
                bounds='body'
                className='tw-z-[90]'
            >
                <div className='tw-border tw-h-full tw-flex tw-flex-col tw-bg-white tw-border-[#dcdddd]'>
                    <div className='tw-bg-[#dcdddd] tw-px-2 tw-h-10 tw-flex tw-flex-row tw-items-center tw-justify-between'>
                        <p className='tw-font-bold'>{t("examFooter.navigator.title")}</p>
                        <div><Icon size='small' onClick={() => setShowNav(false)} link name='delete' bordered /></div>
                    </div>
                    <Navigator
                        Q={Q}
                        Qindex={Qindex}
                        questions={questions}
                        onSelectQuestion={onSelectQuestion}
                        onFlagQuestion={onFlagQuestion}
                        onClose={() => setShowNav(false)}
                        isViewOnly={isViewOnly}
                    />
                </div>
            </Rnd>}

            {showHelp && <Rnd
                default={{
                    x: (window.innerWidth - 600) / 2,
                    y: -(window.innerHeight + 400) / 2,
                    width: 600,
                    height: 400,
                }}
                bounds='body'
                className='tw-z-[90]'
                dragHandleClassName="handlerDragging"
            >
                <div className='tw-border tw-h-full tw-flex tw-flex-col tw-bg-white tw-border-[#dcdddd]'>
                    <div className='handlerDragging tw-cursor-move tw-bg-[#dcdddd] tw-px-2 tw-h-10 tw-flex tw-flex-row tw-items-center tw-justify-between'>
                        <p className='tw-font-bold'>{t("examFooter.help.title")}</p>
                        <div><Icon size='small' onClick={() => setShowHelp(false)} link name='delete' bordered /></div>
                    </div>
                    <Helper />
                </div>
            </Rnd>}
        </>
    );
};

const Navigator = ({ onClose, questions, Qindex, onFlagQuestion, onSelectQuestion, isViewOnly }) => {
    const { t } = useTranslation();
    return (
        <div className='tw-overflow-y-auto tw-flex-1'>
            <Table compact='very' celled striped selectable>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell collapsing><p className='tw-font-bold'>{t("examFooter.navigator.question")}</p></TableHeaderCell>
                        <TableHeaderCell collapsing><p className='tw-font-bold'>{t("examFooter.navigator.status")}</p></TableHeaderCell>
                        <TableHeaderCell collapsing><p className='tw-font-bold'>{t("examFooter.navigator.flagged")}</p></TableHeaderCell>
                    </TableRow>
                </TableHeader>

                <TableBody>
                    {
                        questions.map((q, idx) => {
                            const isAnswerd = q?.answerOptionId || q?.answerText || q?.answerJson;
                            const isSelected = idx === Qindex;
                            return <TableRow onClick={() => { onSelectQuestion(q); onClose(); }} className={`tw-cursor-pointer ${isSelected && "tw-bg-blue-600/20"}`} key={idx}>
                                <TableCell collapsing>{`${t("examFooter.navigator.question")} ${idx + 1}`}</TableCell>
                                <TableCell className='tw-font-bold tw-text-red-500'>{(q?.seen || isViewOnly) ? (isAnswerd ? t("examFooter.navigator.attempted") : t("examFooter.navigator.notAttempted")) : t("examFooter.navigator.unseen")}</TableCell>
                                <TableCell>{q.isFlagged ? <Icon name='flag' color='red' /> : null}</TableCell>
                            </TableRow>;
                        })
                    }
                </TableBody>
            </Table>

        </div >
    );
};

const Helper = () => {
    const { t } = useTranslation();
    const panes = [
        {
            key: 1,
            menuItem: t("examFooter.help.workspaceHelp"),
            render: () => <Tab.Pane key={1}>
                <TbsPdfReader docUrl={WorkSpaceHelpPdf} width={500} scrolling />
            </Tab.Pane>
        },
        {
            key: 2,
            menuItem: t("examFooter.help.examInstructions"),
            render: () => <Tab.Pane key={2}>
                <TbsPdfReader docUrl={ExamInstructionsHelpPdf} width={500} scrolling disableFontFace={false} />
            </Tab.Pane>
        }
    ];
    return (
        <Tab menu={{ color: 'grey', inverted: true, style: { borderRadius: 0 } }} panes={panes} />
    );
};

export default withTranslation()(ExamFooter);